<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Stores transfers operations')"
          :description="$t('From here you can control stores transfers operations')"
        />
        <indexTable
          :searchText="$t('Search for stores transfers operations')"
          :emptyTableText="$t('There are no stores transfers operations')"
          :emptyTableSubText="$t('Try Adding Some Items To The Table And TryAgain')"
          :buttonRole="$checkRole('stores_transfers_add')"
          :statusSearch="true"
          :statusValues="[
            { title: $t('Situation'), value: '' },
            { title: $t('All'), value: '' },
            { title: $t('Draft'), value: 0 },
            { title: $t('Approved'), value: 1 }
          ]"
          :cloumns="[
            {
              column: 'code',
              title: $t('Operation'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'from_store_id',
              title: $t('From store name'),
              element: 'fromStore',
              type: 'link',
              to: 'store',
              sort: true,
              link: true
            },
            {
              column: 'to_store_id',
              title: $t('To store name'),
              element: 'toStore',
              type: 'link',
              to: 'store',
              sort: true,
              link: true
            },
            {
              column: 'date',
              title: $t('The date of the operation'),
              type: 'text',
              sort: true
            },
            {
              column: 'description',
              title: $t('Description'),
              type: 'text',
              sort: true
            },
            {
              column: 'user_name',
              title: $t('Responsible name'),
              type: 'text',
              sort: true
            },
            {
              column: 'status',
              title: $t('Situation'),
              type: 'status',
              sort: true,
              values: [
                { title: $t('Draft'), value: 0, color: 'dark' },
                { title: $t('Approved'), value: 1, color: 'success' }
              ]
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'show' },
                {
                  name: 'edit',
                  role: $checkRole('stores_transfers_edit')
                },
                { name: 'file' },
                { name: 'printStoresTransfer', role: true },
                {
                  name: 'delete',
                  role: $checkRole('stores_transfers_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'

export default {
  data() {
    return {
      path: '/storesTransfers'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
